// extracted by mini-css-extract-plugin
module.exports = {"modal-content-container":"WithdrawalReminder_modal-content-container_1vN96"};